// extracted by mini-css-extract-plugin
export default {"media__card":"MediaCard_media__card__9zR1G"};